import { Box, Group } from '@screentone/core';

import { usePageLock } from 'contexts/page-lock/usePageLock';
import ModuleParameterSettings from 'features/module-parameter-settings/ModuleParameterSettings';
import TreatmentTypesSettings from 'features/treatment-types-settings/TreatmentTypesSettings';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import SiteConfigPage from 'pages/site-config/shared/SiteConfigPage';

function ModuleParameterSettingsWithLock() {
  const { state: lockState } = usePageLock();

  const publishingFragment = lockState.publishing;

  const { isReadOnly } = publishingFragment;

  return <ModuleParameterSettings isReadOnly={isReadOnly} />;
}

function SiteConfigModules() {
  useRequireRoles(ROLE_TYPE.ADMIN);

  return (
    <SiteConfigPage title="Modules & Treatment Types">
      <Group gap="lg" direction="column" fullWidth>
        <Group.Item fullWidth>
          <Box>
            <Box.Title>Module Parameters Config</Box.Title>
            <Box.Content>
              <ModuleParameterSettingsWithLock />
            </Box.Content>
          </Box>
        </Group.Item>
        <Group.Item fullWidth>
          <Box>
            <Box.Title>Treatment Types</Box.Title>
            <Box.Content>
              <TreatmentTypesSettings />
            </Box.Content>
          </Box>
        </Group.Item>
      </Group>
    </SiteConfigPage>
  );
}

export default SiteConfigModules;
